import "./App.css";
import HomePage from "./Pages/HomePage";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import Register from "./Pages/Register";
import SignIn from "./Pages/SignIn";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ServicesPage from "./Pages/Services";
import ConsultingArchitecture from "./Pages/it-consulting-architecture";
import CustomSoftwareSection from "./Pages/custom-software-development";
import CloudMigration from "./Pages/cloud-migration";
import StaffingSolutions from "./Pages/staffing-solutions";
import MobileAppDevelopment from "./Pages/mobileapp-development";
import ApplicationMaintenanceSupport from "./Pages/application-maintenance-support";
import PMOServices from "./Pages/pmo-services";
import SAPSupport from "./Pages/sap-support";




function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/it-consulting-architecture" element={<ConsultingArchitecture/>} />
          <Route path="/custom-software-development" element={<CustomSoftwareSection/>} />
          <Route path="/cloud-migration" element={<CloudMigration/>} />
          <Route path="/staffing-solutions" element={<StaffingSolutions/>} />ApplicationMaintenanceSupport
          <Route path="/mobileapp-development" element={<MobileAppDevelopment/>} />PMOServices
          <Route path="/application-maintenance-support" element={<ApplicationMaintenanceSupport/>} />
          <Route path="/pmo-services" element={<PMOServices/>} />
          <Route path="/sap-support" element={<SAPSupport/>} />




        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
